/**
 * Check if hands-free mode is supported in the current browser
 * Only supports Safari, Chrome, and Edge
 */
export function isHandsFreeModeSupported(): boolean {
  const userAgent = navigator.userAgent;

  // Simple check: only support Chrome, Safari, and Edge
  const isChrome = userAgent.includes("Chrome") && !userAgent.includes("Edg");
  const isSafari =
    userAgent.includes("Safari") && !userAgent.includes("Chrome");
  const isEdge = userAgent.includes("Edg");

  if (!isChrome && !isSafari && !isEdge) return false;
  return true;
}

/**
 * Parse voice commands from transcription text
 */
export function parseVoiceCommands(text: string): {
  command: string | null;
  cleanText: string;
} {
  const lowerText = text.toLowerCase().trim();

  // Voice commands
  const commands = [
    "send message",
    "send a message",
    "cancel message",
    "clear message",
    "stop listening",
    "exit handsfree mode",
    "exit hands free mode",
    "exit hands-free mode",
    "exit conversation mode",
    "stop talking",
    "play video",
    "play a video",
    "pause video",
    "pause a video",
    "close video",
    "close a video",
  ];

  for (const command of commands) {
    if (lowerText.includes(command)) {
      return {
        command,
        cleanText: text
          .replace(new RegExp(command, "gi"), "")
          .replace(/[.,!?;:]/g, "")
          .trim(),
      };
    }
  }

  return {
    command: null,
    cleanText: text,
  };
}

/**
 * Device selection with proper WebGPU detection
 * Returns "webgpu" if available and functional, otherwise "wasm"
 */
export async function detectDevice(): Promise<string> {
  try {
    if (!(navigator as any)?.gpu) {
      return "wasm";
    }

    const adapter = await (navigator as any).gpu.requestAdapter();
    if (!adapter) {
      return "wasm";
    }

    const device = await adapter.requestDevice();
    if (!device) {
      return "wasm";
    }

    return "webgpu";
  } catch (error: any) {
    return "wasm";
  }
}
